import { ASYNC_SUCCESS } from '../actions'

const stats = (state = null, { type, payload }) => {
  switch (type) {
    case ASYNC_SUCCESS:
      switch (payload.actionName) {
        case 'fetchStats': {
          return {
            ...payload.stats
          }
        }

        default:
          return state
      }

    default:
      return state
  }
}

export default stats



// WEBPACK FOOTER //
// ./src/reducers/stats.js